export default __webpack_public_path__ + "static/media/705.b9f8e970.png";